import React, { useState } from "react";

const AccordionItem = ({ heading, body, id, isOpen, onClick, dir }) => {
  return (
    <>
      <h3 id={`accordion-heading-${id}`}>
        <button
          type="button"
          className={`flex items-center justify-between w-full p-5 ${
            dir === "r" && "pl-0"
          } font-medium rtl:text-right text-black border border-x-0  border-b-0  gap-3 ${
            id === 1 && "border-t-0"
          }`}
          onClick={onClick}
          aria-expanded={isOpen}
          aria-controls={`accordion-body-${id}`}
        >
          <h3 className="text-[20px] leading-[27.6px] text-bold text-start">{heading}</h3>
          <span >{isOpen ? "-" : "+"}</span>
        </button>
      </h3>
      <div
        id={`accordion-body-${id}`}
        className={`${isOpen ? "border-b-0" : "hidden"} ${
          dir === "r" ? "p-0" : "p-5"
        } pb-5 border border-t-0  border-x-0 border-gray-200 `}
        aria-labelledby={`accordion-heading-${id}`}
      >
        <p className="text-[14px] leading-[25.76px] md:w-4/5">{body}</p>
      </div>
    </>
  );
};

const AccordionComponent = ({ accordionData, dir }) => {
  const [openIndex, setOpenIndex] = useState(0);

  const handleAccordionClick = (index) => {
    setOpenIndex(index);
  };

  return (
    <>
      <div className={`flex ${dir === "r" && "flex-row-reverse"}  `}>
        {accordionData.map((item, index) => (
          <img
            key={index}
            src={item.imgSrc}
            alt={item.heading + " Image"}
            className={`w-1/2 object-cover hidden ${
              openIndex === index ? "md:block" : "md:hidden"
            }`}
          />
        ))}
        <div
          id="accordion-collapse"
          className={`w-full p-4 ${dir === "r" && "pl-0"}`}
          data-accordion="collapse"
        >
          {accordionData.map((item, index) => (
            <AccordionItem
              key={index}
              id={index + 1}
              heading={item.heading}
              body={item.body}
              isOpen={openIndex === index}
              onClick={() => handleAccordionClick(index)}
              dir={dir}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default AccordionComponent;
